import { service } from '../../../helpers/http'

export const ActionFindTeacherPositions = ({ dispatch }, payload) => {

    return service({
        module: 'teacherPosition',
        action: 'find',
        payload: payload
    })
    
}

export const ActionCreateTeacherPosition = ({ dispatch }, payload) => {
    
    return service({
        module: 'teacherPosition',
        action: 'create',
        payload: payload
    })
    
}

export const ActionUpdateTeacherPosition = ({ dispatch }, payload) => {
    
    return service({
        module: 'teacherPosition',
        action: 'update',
        payload: payload
    })
}

export const ActionDeleteTeacherPosition = ({ dispatch }, payload) => {
    
    return service({
        module: 'teacherPosition',
        action: 'delete',
        payload: payload
    })
    
}

